import { QuickMenuApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';

function usePutOrder() {
  const queryClient = useQueryClient();

  return useAuthMutation(QuickMenuApi.putOrder, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
    },
  });
}

export default usePutOrder;
